const state = {
  user: null,
  address: null,
};

const getters = {
  getUser(state) {
    return state.user;
  },
  getUserName(state) {
    return state.user?.name;
  },
  getUserFirstName(state) {
    return state.user?.name.split(" ")[0];
  },
  getAddress(state) {
    return state.address;
  },
};

const mutations = {
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_ADDRESS(state, payload) {
    state.address = payload;
  },
};

const actions = {
  setUser({ commit }, payload) {
    commit("SET_USER", payload);
  },
  setAddress({ commit }, payload) {
    commit("SET_ADDRESS", payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
